<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper flex flex-col gap-4">
  <h1 class="mat-headline-4 !mb-0">General Settings</h1>

  <form class="flex flex-col gap-4" [formGroup]="form" (ngSubmit)="save()">
    <mat-card appearance="outlined" formGroupName="charting">
      <mat-card-header>
        <mat-card-title class="mb-4">Charting</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="mt-2 flex gap-4 px-4 pt-2">
          <mat-form-field class="w-full">
            <mat-label>Preferred Chart View</mat-label>
            <mat-select required formControlName="view">
              <mat-option
                *ngFor="let chartView of chartViews; trackBy: trackByChartView"
                [value]="chartView"
              >
                {{ chartView }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" formGroupName="chats">
      <mat-card-header>
        <mat-card-title class="mb-4">Chats</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="mt-2 flex flex-col gap-4">
          <pt-settings-menu-select
            label="Notification Sound"
            tooltip="Select sound of chat notifications"
            formControlName="notificationSoundOverride"
            ptElementTarget="notification-sound-override-button"
            [options]="sounds"
          />

          <pt-settings-menu-slide-toggle-item
            label="Show All Practices"
            tooltip="Show all chats across the practices that you have access to"
            formControlName="showAllPractices"
            ptElementTarget="show-all-practices-button"
          />
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" formGroupName="notifications">
      <mat-card-header>
        <mat-card-title class="mb-4">Notifications</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="mt-2 flex flex-col gap-4">
          <pt-settings-menu-select
            label="Patient Arrived Notification Sound"
            tooltip="Select sound for arrived patient notifications"
            formControlName="patientArrivedSoundOverride"
            ptElementTarget="notification-sound-override-button"
            [options]="sounds"
          />
        </div>
      </mat-card-content>
    </mat-card>

    <pt-buttons-container>
      <button mat-flat-button color="primary" [disabled]="!form.valid">
        Save Changes
      </button>
    </pt-buttons-container>
  </form>
</div>
